module.exports = __webpack_public_path__ + "media/assets/icons/envelope-mail-07750c5883e736d336f813582d2e43ad.svg";